
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEnergyOil as ObiEnergyOilElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-energy-oil.js';
 
 
 

 
 export const ObiEnergyOil = createComponent({
   react: React,
   tagName: 'obi-energy-oil',
   elementClass: ObiEnergyOilElement,
   events: {
     
   }
  });
 
 